$(document).ready(function () {
	if ('objectFit' in document.documentElement.style === false) {
		$('body').addClass('no-object-fit');
	}

	var previousScrollTop = 0;
	var allowScrollPast = false;

	if ($('[data-scrolling-banners]').length > 0) {
		var scrollSteps = {
			'in': [
				{
					'banner': { 'opacity': 0, 'width': '200%', 'left': '-50%' },
					'text': { 'opacity': 0, 'transform': 'translateY(20px)' }
				},
				{
					'banner': { 'opacity': 1, 'width': '150%', 'left': '-25%' },
					'text': { 'opacity': 0, 'transform': 'translateY(20px)' }
				},
				{
					'banner': { 'opacity': 1, 'width': '100%', 'left': '0' },
					'text': { 'opacity': 0, 'transform': 'translateY(30px)' }
				}
			],
			'view': [
				{
					'banner': { 'opacity': 1, 'width': '100%', 'left': '0' },
					'text': { 'opacity': 1, 'transform': '' }
				}
			],
			'out': [
				{
					'banner': { 'opacity': 0, 'width': '200%', 'left': '-50%' },
					'text': { 'opacity': 0, 'transform': '' }
				}
			]
		}

		previousScrollTop = $(window).scrollTop();

		$(window).on('scroller.scrolled', function () {
			allowScrollPast = true;
		});

		$(window).on('scroll', $.throttle(function () {
			return scrollHandler();
		}, 100));

		setScrollStep($('[data-scrolling-banners]').find('.banner__link').first(), 'view', 0);
	}

	function scrollHandler() {
		var $banners = $('[data-scrolling-banners]');
		if ($(window).width() > 750) {
			if (allowScrollPast === false) {
				$banners.each(function () {
					var $banner = $(this);
					var scrollMin = Math.floor(getScrollMin($banner));
					var windowScrollTop = $(window).scrollTop();
					if (windowScrollTop > previousScrollTop) {
						if (windowScrollTop > scrollMin && !scrollDown($banner.find('.banner__link'))) {
							windowScrollTop = scrollMin;
							$(window).scrollTop(scrollMin);
						}
					}
					previousScrollTop = windowScrollTop;
				});
			}
		} else {
			$banners.each(function () {
				var $banner = $(this);
				resetAllBanners($banner.find('.banner__link'));
			});
		}
	}

	function resetAllBanners($allBanners) {
		$allBanners.find('.banner__image').css('opacity', '').css('width', '').css('left', '');
		$allBanners.find('.banner__content').css('opacity', '').css('transform', '');
		for (var i = 0; i < $allBanners.length; i++) {
			$.removeData($allBanners[i], 'scrollStep');
		}
	}

	function setScrollStep($banner, action, currentScrollStep) {
		var $activeBanner = $banner;
		if (typeof $activeBanner.data('scrollStep') === 'undefined') {
			var $allBanners = $banner.parent().find('.banner__link');
			resetAllBanners($allBanners);
		}

		var styles = scrollSteps[action][currentScrollStep];

		$activeBanner.find('.banner__image').css(styles['banner']);

		if ('objectFit' in document.documentElement.style === false) {
			var bannerWidth = $activeBanner.outerWidth();
			var bannerHeight = $activeBanner.outerHeight();
			var $bannerImage = $activeBanner.find('.banner__image');
			var imageWidth = $bannerImage.outerWidth();
			var imageHeight = $bannerImage.outerHeight();
			var fullWidthFactor = imageWidth / bannerWidth;
			var imageHeightAtFullWidth = imageHeight / fullWidthFactor;
			if (imageHeightAtFullWidth < bannerHeight) {
				var fullHeightFactor = bannerHeight / imageHeightAtFullWidth;
				var width = parseInt(styles['banner']['width'].replace('%', ''));
				if (width !== NaN) {
					width = width * fullHeightFactor;
					$activeBanner.find('.banner__image').css('width', width + '%');
				}
			}
		}

		$activeBanner.find('.banner__content').css(styles['text']);

		$activeBanner.data('action', action);
		$activeBanner.data('scrollStep', currentScrollStep);
	}

	function transitionToBanner($currentBanner, $nextBanner) {
		var currentScrollStep = 0;
		var action = 'out';
		var $banner = $currentBanner;
		setScrollStep($currentBanner, 'out', currentScrollStep++);
		var autoScroll = setInterval(function () {
			if (action == 'out') {
				if (currentScrollStep == scrollSteps['out'].length) {
					action = 'in';
					currentScrollStep = 0;
					$banner = $nextBanner;
				}
			} else if (action == 'in') {
				if (currentScrollStep == scrollSteps['in'].length) {
					action = 'view';
					currentScrollStep = 0;
					clearInterval(autoScroll);
				}
			}

			setScrollStep($banner, action, currentScrollStep++);
		}, 250);
	}

	function scrollDown($allBanners) {
		var currentBannerIndex = 0;
		for (var i = 0; i < $allBanners.length; i++) {
			if (typeof $.data($allBanners[i], 'scrollStep') !== 'undefined') {
				currentBannerIndex = i;
			}
		}

		var $currentBanner = $($allBanners[currentBannerIndex]);
		var currentScrollStep = $currentBanner.data('scrollStep');
		if (typeof currentScrollStep == 'undefined') {
			currentScrollStep = -1;
		}

		var action = $currentBanner.data('action');
		if (typeof action == 'undefined') {
			action = 'in';
		}

		currentScrollStep += 1;
		if (currentScrollStep == scrollSteps[action].length && action == 'view') {
			// transition to the next banner, unless this is the last one in which case we can release the user from this prison
			if (currentBannerIndex < $allBanners.length - 1) {
				transitionToBanner($currentBanner, $($allBanners[currentBannerIndex + 1]));
				return false;
			} else {
				return true;
			}
		} else {
			// user is trying to scroll during animation - MUST NOT LET THEM THEY MUST SEE THESE IMPORTANT BANNERS
			return false;
		}
	}

	function getScrollMin($banner) {
		var bannerTop = $banner.offset().top;
		var headerHeight = $('header').outerHeight(false);
		var windowHeight = $(window).height();
		var bannerHeight = $banner.outerHeight(false);
		var remainingHeight = windowHeight - headerHeight - bannerHeight;

		var stopScrollingAt = bannerTop - headerHeight;
		if (remainingHeight > 0) {
			stopScrollingAt -= remainingHeight / 2;
		}

		return stopScrollingAt;
	}
});